import React, { useState, useEffect, useMemo, useRef } from "react";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import ReactPaginate from "react-paginate";
import { CircularProgress, Skeleton, Tooltip } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../constants/DeleteModal";
import Messages from "../../../constants/Messages";
import ViewPaylater from "../paylater/ViewPaylater";
import PasswordManager from "./CloudPassword/Password";
import EstimateList from "./EstimateList";
import { usePermission } from "../../../context/PermissionContext";
import uRLs from "../../../utils/baseUtils";
import EditCutomer from "./EditCustomer";
import { useAuth } from "../../../context/AuthProvider";
import JobCardList from "./JobCardList";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import AddGroup from "./AddGroup";
import ReturnSaleList from "./ReturnSaleList";
import { useSaleContext } from "../../../context/SaleContext";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { BuildingIcon, CheckIcon, ChevronDownIcon, CreditCardIcon, CustomersAddIcon, CustomersIcon, DeleteIcon, EditIcon, EnvelopeIcon, HomeIcon, IdCardIcon, LeftArrowAltIcon, MapIcon, PhoneIcon, RightArrowAltIcon, ShowIcon, TimerIcon, UserIcon, XIcon } from "../../../constants/Icons";

const CustomerView = ({
  isOpen,
  onClose,
  customerId,
  setCustomerData,
  setCustTotalItems,
  onUpdate,
  OnDelete,
  selectMy,
  selectAll,
  onChangeGroup,
  onEditGroupData,
  selectedGroupDetails,
  groupId,
  onNewGroupsSet,
  customerList,
  index,
  setIndex,
  isActive,
  totalCustomer
}) => {
  const [activeTab, setActiveTab] = useState("customer");
  const [tabIndex, setTabIndex] = useState(0);
  const [customerData, setCustomerDetails] = useState(null);
  const { updateSettings, isUser } = useAuth();
  const [custId, setCustId] = useState();
const { isSaleData, setSaleData } = useSaleContext();
  // const [salesData, setSalesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isPaylaterData, setPaylaterData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSearchTerm, setSearchTerm] = useState("");
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [isDeleteData, setDeleteData] = useState(null);

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const {
    permission,
    hasModulePermission,
    blockedPermissions,
    activeStoreModules,
    customerGroups,
    hasPermission,
    storeSettings,
  } = usePermission();
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);
  // 🔹 Separate loaders
  const [isCustomerLoading, setIsCustomerLoading] = useState(true);
  const [isSalesLoading, setIsSalesLoading] = useState(true);

  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [isSelectedPlater, setSelectedPlater] = useState(false);
  const [buttonLoading, setButtonLoading] = useState({ type: "", id: null });
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);
  const [newGroupName, setNewGroupName] = useState(null);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [customerGroupOpen, setCustomerGroupOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(selectedGroupDetails);
  const suggestionRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const perPage = 10;
  useEffect(() => {
    if (isOpen && customerId) {
      fetchCustomerDetails(customerId);
    }
  }, [isOpen, customerId]);

  useEffect(() => {
    if (activeTab === "sales" && customerData?.customerData?._id) {
      fetchSalesDetails(customerData.customerData._id, currentPage);
      console.log(customerData?.customerData?._id);
    }
  }, [activeTab, customerData, currentPage]);

  const fetchCustomerDetails = async (id) => {
    try {
      setIsCustomerLoading(true);
      const response = await AxiosInstance.get(`module/customer/details/${id}`);
      setCustomerDetails(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsCustomerLoading(false);
    }
  };
  const handleNextCustomer = () => {
    if (!customerList?.length) return;
    setIndex((prev) => {
      // if (prev >= customerList.length - 1) return prev;
      const newIndex = prev >= customerList.length - 1 ? 0 : prev + 1;

      const indexData = customerList[newIndex];
      console.log(indexData?._id);
      fetchCustomerDetails(indexData?._id);
      setActiveTab("customer");
      return newIndex;
    });
  };
  const handlePrevCustomer = () => {
    if (!customerList?.length) return;
    setIndex((prev) => {
      // if (prev <= 0) return prev;
      const newIndex = prev <= 0 ? customerList.length - 1 : prev - 1;

      const indexData = customerList[newIndex];
      fetchCustomerDetails(indexData?._id);
      setActiveTab("customer");
      return newIndex;
    });
  };
  const handleArrowNavigation = (e) => {
    // ignore if typing in input/textarea
    const tag = e.target.tagName.toLowerCase();
    if (tag === "input" || tag === "textarea") return;

    if (e.key === "ArrowRight") {
      e.preventDefault();
      handleNextCustomer();
    }

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      handlePrevCustomer();
    }
  };
  const handleViewPaylater = (customer) => {
    const updatedCustomer = {
      ...customer.customerData,
      customerid: customer.customerData._id,
    };

    setSelectedPlater(updatedCustomer);
  };

  const handleClosePaylater = () => {
    setSelectedPlater(false);
  };

  const handleListPaylater = async (page = 0, term = "") => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      // const data = { searchtxt: term, pageno: page + 1, perpage: perPage };
      const response = await AxiosInstance.get(
        `module/paylater?pageno=${page + 1}&limit=${perPage}&searchtxt=${term}`,
      );
      const results = response.data.results || [];
      setPaylaterData(results);

      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleDataUpdate = () => {
    handleListPaylater(currentPage, isSearchTerm);
  };
  useEffect(() => {
    window.addEventListener("keydown", handleArrowNavigation);
    return () => {
      window.removeEventListener("keydown", handleArrowNavigation);
    };
  }, [customerList]);

  const fetchSalesDetails = async (customerId, page = 0) => {
    try {
      setIsSalesLoading(true);
      const response = await AxiosInstance.get(
        `module/sale/customer/${customerId}?pageno=${page + 1}&limit=${perPage}`,
      );
      const { results, totalItems, totalPages } = response.data;
      setSaleData(results || []);
      setTotalItems(totalItems || 0);
      setTotalPages(totalPages || 0);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsSalesLoading(false);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleView = async (item) => {
    setButtonLoading({ type: "view", id: item._id });
    try {
      const data = await handleSaleItems(item._id);
      if (data) {
        setViewData(data);
        setViewModalOpen(true);
        setViewTempModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
      setButtonLoading({ type: "", id: null });
    }
  };

  const handleEdit = async (item) => {
    if (blockedPermissions("SALE:update") || permission === undefined) {
      setButtonLoading({ type: "edit", id: item._id });

      try {
        const data = await handleSaleItems(item._id);

        if (data) {
          if (data.consumeVersion === "CONSUMEV2") {
            navigate("/editsale", { state: data });
          } else {
            navigate("/editsaleold", { state: data });
          }
        }
      } catch (error) {
        console.error("Error loading sale data:", error);
      } finally {
        setButtonLoading({ type: "", id: null });
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
      "website",
    ];

    let hasChange = false;

    for (const key of editableKeys) {
      const originalValue = String(
        key.startsWith("shipping")
          ? isEditData.shippingAddress?.[
              key.replace("shipping", "").toLowerCase()
            ]
          : key.startsWith("contactPerson")
            ? isEditData.contactPerson?.[
                key === "contactPersonname" ? "name" : "number"
              ]
            : isEditData[key] || "",
      );

      const updatedValue = String(updatedData[key] || "");

      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }
    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );

      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerDetails((prev) => ({
        ...prev,
        customerData: response.data.results,
      }));
      setSelectedCustomer((prev) => ({
        ...prev,
        customerData: response.data.results,
      }));

      const updatedCustomer = response.data.results;
      const updatedCustomerId = updatedCustomer?._id;

      const originalGroupId = isEditData?.groupid || "";
      const newGroupId = updatedData.groupid || "";
      const groupIdChanged = originalGroupId !== newGroupId;

      if (setCustomerData) {
        if (groupIdChanged) {
          setCustTotalItems((prevCount) => prevCount + 1);
        }
        setCustomerData((prevCustomerData) => {
          if (groupIdChanged) {
            const filteredData = prevCustomerData.filter(
              (customer) => customer._id !== updatedCustomerId,
            );
            // setCustTotalItems(prevCount => prevCount + 1);
            return [updatedCustomer, ...filteredData];
          } else {
            return prevCustomerData.map((customer) =>
              customer._id === updatedCustomerId ? updatedCustomer : customer,
            );
          }
        });
      } else {
        onUpdate(response.data?.results);
      }
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const openEditModal = (cItem) => {
    if (blockedPermissions("CUSTOMER:view") || permission === undefined) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;

      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });
      onNewGroupsSet(results);
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      openEditModal(isEditData);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  const openDeleteModal = (cItem) => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const tabs = [
    {
      id: "customer",
      label: "Overview",
      icon: "bx bx-user",
    },
    ...(hasModulePermission("SALE") || permission === undefined
      ? [{ id: "sales", label: "Sale Details", icon: "bx bx-cart" }]
      : []),
    ...(uRLs.DASHBOARD_PASSWORD === "true" &&
    (hasModulePermission("PASSWORD") || permission === undefined) &&
    activeStoreModules("PASSWORD")
      ? [{ id: "password", label: "Password", icon: "bx bx-key" }]
      : []),
    ...(uRLs.ESTIMATE_MODULE === "true" &&
    activeStoreModules("ESTIMATE") &&
    (hasModulePermission("ESTIMATE") || permission === undefined)
      ? [{ id: "estimate", label: "Estimate Details", icon: "bx bx-notepad" }]
      : []),
    ...(uRLs.RETURN_SALE === "true"
      ? [
          {
            id: "returnsale",
            label: "Return Sale Details",
            icon: "bx bx-undo",
          },
        ]
      : []),

    ...(uRLs.JOBCARD === "true" &&
    activeStoreModules("JOBCARD") &&
    (hasModulePermission("JOBCARD") || permission === undefined)
      ? [{ id: "jobCard", label: "JobCard Details", icon: "bx bx-id-card" }]
      : []),
  ];

  const handleDelete = async () => {
    try {
      if (!checkNetwork()) return;
      setBtnLoading(true);
      // const data = { customerid: isDeleteData._id };
      await AxiosInstance.delete(`module/customer/${isDeleteData._id}`);
      showAlert("success", Messages.SUCCESS.CUSTOMER_DELETED);
      //   setCustomerDetails((prevData) =>
      //    prevData.filter((customer) => customer._id !== isDeleteData._id)
      //  );
      OnDelete(isDeleteData);

      //  setTotalItems((prev) => prev - 1);

      // const newTotal = totalItems - 1;
      // const newTotalPages = Math.ceil(newTotal / perPage);

      // if (isCustomerData.length === 1 && currentPage > 0) {
      //   setCurrentPage((prev) => prev - 1);
      //   await handleListCustomer(currentPage - 1, isSearchTerm);
      // } else {
      //   await handleListCustomer(currentPage, isSearchTerm);
      // }

      // setTotalItems(newTotal);
      // setTotalPages(newTotalPages);
      setDeleteModalOpen(false);
      onClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECEIPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const getBgColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-honey";
      case "invoice":
        return "bg-label-moon";
      default:
        return "bg-label-secondary";
    }
  };

  const getBgTxtColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-wave";
      case "invoice":
        return "bg-label-deep-purple";
      default:
        return "bg-label-secondary";
    }
  };

 const getColor = (saleTrack, status) => {
    switch (saleTrack?.toUpperCase()) {
      case "ADDED":
        return "bg-label-success"; // Green
      case "UPDATED":
        return "bg-label-warning"; // Yellow
      case "DELETED":
        return "bg-label-danger"; // Red
      case "RETURNED":
        return "bg-label-info"; // Blue
      default:
        switch (status?.toLowerCase()) {
          case "active":
            return "bg-label-success";
          case "cancelled":
            return "bg-label-danger";
          default:
            return "bg-label-secondary";
        }
    }
  };

  const getStatusLabel = (saleTrack, status) => {
    switch (saleTrack?.toUpperCase()) {
      case "ADDED":
        return "Original";
      case "UPDATED":
        return "Modified";
      case "DELETED":
        return "Cancelled";
      case "RETURNED":
        return "Returned";
      default:
        return status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
    }
  };  

  const handleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
  };
  const handleKeyDown = (e) => {
    if (!customerGroupOpen) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => (prev < groupName.length + 1 ? prev + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => (prev > 0 ? prev - 1 : groupName.length + 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (activeIndex === 0) {
        isUser.stype === "MAIN" ? handleSelectAll() : handleSelectMy();
      } else if (activeIndex > 0 && groupName[activeIndex - 1]) {
        handleSelectGroup(groupName[activeIndex - 1]);
      } else if (
        activeIndex === groupName.length + 1 &&
        isUser.stype === "MAIN"
      ) {
        handleNewGroupOpen();
      }
    }
  };
  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  useEffect(() => {
    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  useEffect(() => {
    if (customerGroupOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [customerGroupOpen]);

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  if (!isOpen) return null;

  const formatCurrency = (value) => {
    const formatted = CurrencyConverter.toCurrency(Math.abs(value), "INR");
    return value < 0 ? `- ₹${formatted}` : `₹${formatted}`;
  };

  const handleSelectAll = () => {
    setSelectedGroup({ name: "All Customer" });
    setCustomerData((prev) => {
      const { groupid, ...rest } = prev; // remove groupid
      return rest;
    });
    setCustomerGroupOpen(false);
    if (onChangeGroup) onChangeGroup({ name: "All Customer" });
  };
  const handleSelectMy = () => {
    setSelectedGroup({ name: "My Customer" });
    setCustomerData((prev) => {
      const { groupid, ...rest } = prev; // remove groupid
      return rest;
    });
    setCustomerGroupOpen(false);
    if (onChangeGroup) onChangeGroup({ name: "My Customer" });
  };
  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
    setCustomerGroupOpen(false);
  };
  const handleSelectGroup = async (group) => {
    try {
      if (customerData?.customerData?.groupid === group._id) {
        showAlert("warning", "Already in this group");
        return;
      }
      const data = {
        customerid: customerData?.customerData?._id,
        groupid: group._id,
        country: customerData?.customerData?.country,
      };
      await AxiosInstance.patch(
        `module/customer/${customerData?.customerData?._id}`,
        data,
      );

      if (!selectAll && !selectMy) {
        console.log("selectMyselectMy");
        setCustomerData((prev) =>
          prev.filter((item) => item._id !== customerData?.customerData?._id),
        );
        setCustTotalItems((prev) => prev - 1);
      }
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      setCustomerGroupOpen(false);
      onClose();
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setCustomerGroupOpen(false);
    }
  };
  const handleGrouAdd = (groupName) => {
    handleCustomerGroupAdd(groupName);
    handleNewGroupClose();
  };
  const customerGroup = groupName?.find(
    (group) => group?._id === customerData?.customerData?.groupid,
  );

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content" style={{ minHeight: "250px" }}>
            <div className="modal-header">
              {/* <h5 className="modal-title">Customer View</h5> */}
              <div className="d-flex align-items-center text-center modal-title pe-3">
                Customer View{" "}
                {customerData?.customerData?.name && (
                  <>
                    -{" "}
                    <span className="d-flex align-items-center justify-content-between badge rounded-pill bg-label-infoss cursor-poInter ">
                      <span className="me-2">
                        <UserIcon iClass={"fs-6"}/>
                      </span>
                      <span className="me-1">
                     <Tooltip title={customerData?.customerData?.name || ""} arrow placement="top">
                                <span
                                  className="text-truncate d-inline-block align-middle"
                                  style={{ maxWidth: "300px" }}
                                >
                                  {customerData?.customerData?.name}
                                </span>
                              </Tooltip>                        
                        {/* {customerData?.customerData?.name} */}
                      </span>
                    </span>
                  </>
                )}
                {customerData?.customerData?.phone && (
                  <>
                    -{" "}
                    <span className="d-flex align-items-center justify-content-between badge rounded-pill bg-label-infoss cursor-poInter ">
                      <span className="me-2">
                        <PhoneIcon iClass={"fs-6"}/>
                      </span>
                      <span className="me-1">
                        {customerData?.customerData?.phone}
                      </span>
                    </span>
                  </>
                )}
              </div>
              <div
                className="position-relative"
                ref={dropdownRef}
                tabIndex={0}
                onKeyDown={handleKeyDown}
                style={{ outline: "none" }}
              >
                {/* Dropdown Button */}
                <div
                  onClick={() => {
                    setCustomerGroupOpen(true);
                    setActiveIndex(0);
                  }}
                  className="d-flex align-items-center justify-content-between p-1 border cursor-pointer bg-white shadow-sm"
                  style={{
                    borderRadius: "12px",
                    minWidth: "220px",
                    transition: "0.2s",
                  }}
                >
                  {/* Left */}
                  <div className="d-flex align-items-center overflow-hidden">
                    <div
                      className="d-flex align-items-center justify-content-center me-2"
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "8px",
                        background: "#fff4e5",
                        color: "#f59e0b",
                      }}
                    >
                      <CustomersIcon iClass={"fs-6"}/>
                    </div>

                    <div className="overflow-hidden">
                      <p
                        className="mb-0 fw-600 text-truncate font-12"
                        style={{ maxWidth: "130px" }}
                      >
                        {customerGroup?.name ||
                          selectedGroup?.name ||
                          (isUser.stype === "MAIN"
                            ? "All Customer"
                            : "My Customer")}
                      </p>

                      <small className="text-muted">
                        Change customer group
                      </small>
                    </div>
                  </div>

                  {/* Right Arrow */}
                  <ChevronDownIcon iClass={"fs-5 text-muted"}/>
                </div>

                {/* Dropdown List */}
                {customerGroupOpen && groupName && (
                  <div
                    className="position-absolute bg-white shadow border mt-2 w-100"
                    style={{
                      borderRadius: "12px",
                      zIndex: 1000,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="px-3 py-2 border-bottom text-muted fw-600  font-12"
                      style={{
                        background: "#fafafa",
                      }}
                    >
                      Select Group
                    </div>

                    <ul
                      className="list-unstyled mb-0"
                      style={{
                        maxHeight: "260px",
                        overflowY: "auto",
                      }}
                    >
                      {isUser.stype === "MAIN" ? (
                        <li
                          ref={(el) => (suggestionRefs.current[0] = el)}
                          onClick={handleSelectAll}
                          className={`px-3 py-2 d-flex align-items-center cursor-pointer ${
                            activeIndex === 0 ? "bg-light" : ""
                          }`}
                        >
                          <CustomersIcon iClass={"me-2"}/>
                          All Customer
                        </li>
                      ) : (
                        <li
                          ref={(el) => (suggestionRefs.current[0] = el)}
                          onClick={handleSelectMy}
                          className={`px-3 py-2 d-flex align-items-center cursor-pointer ${
                            activeIndex === 0 ? "bg-light" : ""
                          }`}
                        >
                          <CustomersIcon iClass={"me-2"}/>
                          My Customer
                        </li>
                      )}

                      {groupName?.map((customer, index) => (
                        <li
                          key={customer?._id}
                          ref={(el) => (suggestionRefs.current[index + 1] = el)}
                          onClick={() => handleSelectGroup(customer)}
                          className={`px-3 py-2 d-flex align-items-center suggestion-item justify-content-between cursor-pointer ${
                            activeIndex === index + 1 ? "active-suggestion" : ""
                          }`}
                        >
                          <div className="d-flex align-items-center">
                            <CustomersIcon iClass={"me-2"}/>
                            {customer?.name}
                          </div>

                          {selectedGroup?._id === customer?._id && (
                            <CheckIcon iClass={"text-success"}/>
                          )}
                        </li>
                      ))}

                      {isUser.stype === "MAIN" && (
                        <li
                          ref={(el) =>
                            (suggestionRefs.current[groupName?.length + 1] = el)
                          }
                          onClick={handleNewGroupOpen}
                          className={`suggestion-item d-flex align-items-center bg-label-infos ${
                            activeIndex === groupName?.length + 1
                              ? "active-suggestion"
                              : ""
                          }`}
                        >
                          <CustomersAddIcon iClass={"me-2 fs-6"}/>
                          New Group
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>

              <div className="d-flex align-items-center fw-bold text-dark mb-0 ms-auto me-2">
                <button
                  type="button"
                  className="btn bg-label-infoss shadow-none  me-4 py-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    openEditModal(customerData?.customerData);
                  }}
                >
                  <EditIcon iClass={"me-2"}/>Edit
                </button>
                <button
                  type="button"
                  className="btn-close border"
                  onClick={onClose}
                ></button>
              </div>
            </div>

            <div className="modal-body p-0 d-flex" style={{ height: "100%" }}>
              <div className="border-end" style={{ width: "200px" }}>
                <ul className="list-unstyled m-0 p-2" tabIndex={0}>
                  {tabs.map((tab, index) => (
                    <li
                      key={tab?.id}
                      onClick={() => {
                        setActiveTab(tab.id);
                        setTabIndex(index); // sync click + keyboard
                      }}
                      className={`p-2 mb-1 rounded cursor-pointer fw-bold d-flex align-items-center gap-2 ${
                        activeTab === tab.id ? "text-primary" : "text-muted"
                      } ${tabIndex === index ? "bg-light" : ""}`}
                      style={{
                        backgroundColor:
                          activeTab === tab.id
                            ? "#e8f0fe"
                            : tabIndex === index
                              ? "#f1f1f1"
                              : "transparent",
                      }}
                      onMouseEnter={(e) => {
                        if (activeTab !== tab?.id) {
                          e.currentTarget.style.backgroundColor = "#f1f1f1";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (activeTab !== tab?.id) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      <i className={`${tab?.icon}`}></i> {/* Icon */}
                      {tab?.label}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right Content */}
              <div className="px-3 py-1 flex-grow-1">
                {activeTab === "customer" && (
                  <>
                    {isCustomerLoading ? (
                      <div
                        className="d-flex justify-content-center align-items-center p-2"
                        style={{ minHeight: "200px" }}
                      >
                        <CircularProgress />
                      </div>
                    ) : customerData ? (
                      <div className="card shadow-sm border-0 rounded-3 p-3">
                        {/* Header with Name + Paylater */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div className="fw-bold text-dark mb-0">
                            <UserIcon iClass={"fs-5 text-dark"}/>{" "}
                            <span className="fs-5 text-break">
                              {customerData?.customerData?.name}
                              {customerData?.customerData?.nickname &&
                                ` (${customerData?.customerData?.nickname})`}
                            </span>
                            {/* <span className="ms-2">
                              <span
                                type="button"
                                className="btn-label-primary shadow-none p-1 rounded fs-6"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openEditModal(customerData?.customerData);
                                }}
                              >
                                <i className="ng ng-ng-edit-icon me-1"></i>Edit
                                Customer
                              </span>
                            </span> */}
                          </div>

                          {/* Paylater section */}
                          {customerData?.paylaterData && (
                            <div className="text-end">
                              <button
                                onClick={() => handleViewPaylater(customerData)}
                                className={`btn btn-deep-gray shadow-none " ${
                                  customerData?.paylaterData?.closeamount < 0
                                    ? "bg-label-danger text-white"
                                    : "bg-label-success text-white"
                                }`}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                <TimerIcon iClass={"text-dark"}/>{" "}
                                <span className="fw-semibold text-dark">
                                  Paylater Amount:{" "}
                                </span>
                                <span
                                  className={`badge rounded-pill ${
                                    customerData?.paylaterData?.closeamount < 0
                                      ? "bg-label-danger text-white"
                                      : "bg-label-success text-white"
                                  }`}
                                >
                                  {formatCurrency(
                                    customerData?.paylaterData?.closeamount,
                                  )}
                                </span>
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Phone */}

                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <PhoneIcon/>
                            </button>
                            <span className="fw-semibold text-muted">
                              Phone:
                            </span>
                            <span className="text-dark">
                              {customerData?.customerData?.phone || "-"}
                            </span>
                          </div>
                          {customerData?.customerData?.tradeName && (
                            <div
                              className="mb-2 d-flex align-items-center gap-2"
                              style={{ flexBasis: "50%" }}
                            >
                              <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                                <UserIcon iClass={"fs-5"}/>
                              </button>
                              <span className="fw-semibold text-muted">
                                Trade Name:
                              </span>
                              <span className="text-dark">
                                {customerData?.customerData?.tradeName || "-"}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <EnvelopeIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">
                              Email:
                            </span>
                            <span className="text-dark text-break">
                              {customerData?.customerData?.email || "-"}
                            </span>
                          </div>
                          <div
                            className="mb-2 d-flex align-items-center gap-2 ms-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <CreditCardIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">GST:</span>
                            <span className="text-dark">
                              {customerData?.customerData?.gstnumber || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "100%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <HomeIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">
                              Billing Address:
                            </span>
                            <span className="text-dark">
                             {[
                              customerData?.customerData?.addressline1,
                              customerData?.customerData?.addressline2,
                              customerData?.customerData?.district,
                              customerData?.customerData?.state,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                            {customerData?.customerData?.pincode ? ` - ${customerData.customerData.pincode}` : ""}
                            </span>
                          </div>
                        </div>
                        {/* <div className="mb-2 d-flex justify-content-between align-items-start">
                          
                          <div className="d-flex align-items-center gap-2">
                          <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                            <i className="bx bx-phone"></i>
                            </button>
                            <span className="fw-semibold text-muted">
                              Phone:
                            </span>
                            <span className="text-dark">
                              {customerData?.customerData?.phone || "-"}
                            </span>
                          </div>

                          {customerData?.customerData?.tradeName && (
                            <div className="text-end">
                              <div className="d-flex align-items-center gap-2 justify-content-end">
                              <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                                <i className="bx bx-user fs-5 "></i>
                                </button>
                                <span className="fw-semibold text-muted">
                                  Trade Name:
                                </span>
                                <span className="text-dark">
                                  {customerData?.customerData?.tradeName || "-"}
                                </span>
                              </div>
                            </div>
                          )}
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-envelope fs-5 "></i>
                          </button>
                          <span className="fw-semibold text-muted">Email:</span>
                          <span className="text-dark">
                            {customerData?.customerData?.email || "-"}
                          </span>
                        </div> */}
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <MapIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">
                              State:
                            </span>
                            <span className="text-dark">
                              {customerData?.customerData?.state || "-"}
                            </span>
                          </div>
                          <div
                            className="mb-2 d-flex align-items-center gap-2 ms-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <BuildingIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">CIN:</span>
                            <span className="text-dark">
                              {customerData?.customerData?.cinnumber || "-"}
                            </span>
                          </div>
                        </div>
                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-home fs-5 "></i>
                          </button>
                          <span className="fw-semibold text-muted">
                            Address:
                          </span>
                          <span className="text-dark">
                            {customerData?.customerData?.addressline1 || ""}
                            {customerData?.customerData?.addressline2
                              ? `, ${customerData?.customerData?.addressline2}`
                              : ""}{" "}
                            {customerData?.customerData?.district || ""}{" "}
                            {customerData?.customerData?.country || ""} -{" "}
                            {customerData?.customerData?.pincode || ""}
                          </span>
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-map fs-5 "></i>
                          </button>
                          <span className="fw-semibold text-muted">State:</span>
                          <span className="text-dark">
                            {customerData?.customerData?.state || "-"}
                          </span>
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-credit-card fs-5 "></i>
                          </button>
                          <span className="fw-semibold text-muted">GST:</span>
                          <span className="text-dark">
                            {customerData?.customerData?.gstnumber || "-"}
                          </span>
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-building fs-5 "></i></button>
                          <span className="fw-semibold text-muted">CIN:</span>
                          <span className="text-dark">
                            {customerData?.customerData?.cinnumber || "-"}
                          </span>
                        </div> */}
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <IdCardIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">PAN:</span>
                            <span className="text-dark">
                              {customerData?.customerData?.pannumber || "-"}
                            </span>
                          </div>
                          <div
                            className="mb-2 d-flex align-items-center gap-2 ms-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <UserIcon iClass={"fs-5"}/>
                            </button>
                            <span className="fw-semibold text-muted">
                              Contact Person:
                            </span>
                            <span className="text-dark">
                              {customerData?.customerData?.contactPerson
                                ?.name || "-"}
                            </span>
                          </div>
                        </div>
                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-id-card fs-5 "></i></button>
                          <span className="fw-semibold text-muted">PAN:</span>
                          <span className="text-dark">
                            {customerData?.customerData?.pannumber || "-"}
                          </span>
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-user fs-5 "></i></button>
                          <span className="fw-semibold text-muted">
                            Contact Person:
                          </span>
                          <span className="text-dark">
                            {customerData?.customerData?.contactPerson?.name ||
                              "-"}
                          </span>
                        </div> */}

                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <i className="bx bx-phone fs-5 "></i></button>
                          <span className="fw-semibold text-muted">
                            Contact Number:
                          </span>
                          <span className="text-dark">
                            {customerData?.customerData?.contactPerson
                              ?.number || "-"}
                          </span>
                        </div> */}
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "100%" }}
                          >
                            <button
                              type="button"
                              className="btn bg-label-infoss shadow-none rounded-3 text-right"
                            >
                              <LocalShippingTwoToneIcon className="" />
                            </button>
                            <span className="fw-semibold text-muted">
                              Shipping Address:
                            </span>
                            <span className="text-dark">
                              {[
                                customerData?.customerData?.shippingAddress?.addressline1,
                                customerData?.customerData?.shippingAddress?.addressline2,
                                customerData?.customerData?.shippingAddress?.district,
                                customerData?.customerData?.shippingAddress?.state,
                                customerData?.customerData?.shippingAddress?.country,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                              {customerData?.customerData?.shippingAddress?.pincode
                                ? ` - ${customerData.customerData.shippingAddress.pincode}`
                                : ""}
                            </span>
                          </div>
                        </div>
                        {/* <div className="mb-2 d-flex align-items-center gap-2">
                        <button
                                type="button"
                                className="btn bg-label-infoss shadow-none rounded-3 text-right"
                              >
                          <LocalShippingTwoToneIcon className="" /></button>
                          <span className="fw-semibold text-muted">
                            Shipping Address:
                          </span>
                          <span className="text-dark">
                            {customerData?.customerData?.shippingAddress
                              ?.addressline1 || ""}
                            {customerData?.customerData?.shippingAddress
                              ?.addressline2
                              ? `, ${customerData?.customerData?.shippingAddress?.addressline2}`
                              : ""}{" "}
                            {customerData?.customerData?.shippingAddress
                              ?.district || ""}{" "}
                            {customerData?.customerData?.shippingAddress
                              ?.country || ""}{" "}
                            -{" "}
                            {customerData?.customerData?.shippingAddress
                              ?.pincode || ""}
                          </span>
                        </div> */}

                        <div className="order-actions d-flex align-items-center justify-content-end gap-2">
                          <button
                            type="button"
                            className="btn-label-danger shadow-none me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(customerData?.customerData);
                            }}
                          >
                            <DeleteIcon/>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p>No customer details found.</p>
                    )}
                  </>
                )}

                {activeTab === "sales" && (
                  <>
                    {isSalesLoading ? (
                      <div className="table-responsive ">
                        <table className="table align-middle mb-0">
                          <tbody>
                            {[...Array(perPage)].map((_, index) => (
                              <tr key={index}>
                                {[...Array(8)].map((__, i) => (
                                  <td key={i} className="text-center">
                                    <Skeleton
                                      variant="text"
                                      width={i === 0 ? 50 : 100}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : isSaleData?.length > 0 ? (
                      <>
                        {/* <div className="table-responsive mt-3">
                        <table className="table align-middle mb-0">
                          <thead className="table-light text-center">
                            <tr>
                              <th>S.No</th>
                              <th>Sale Mode</th>
                              <th>Sale No</th>
                              <th>Date</th>
                              <th>Sale Items</th>
                              <th>Grand Total</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {salesData?.map((sale, index) => (
                              <tr
                                key={sale._id || index}
                                className="cursor-poInter hover-row"
                                onClick={() => handleView(sale)}
                              >
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">
                                  {sale?.salemode && (
                                    <span
                                      className={`badge rounded-pill ${getBgColor(
                                        sale?.salemode
                                      )}`}
                                    >
                                      {formatTrackMode(sale?.salemode)}
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  {sale?.salemode && (
                                    <span
                                      className={`badge rounded-pill ${getBgTxtColor(
                                        sale?.salemode
                                      )}`}
                                    >
                                      {sale?.saleno}
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <div className="d-flex flex-column">
                                    <span className="text-nowrap text-heading fw-medium">
                                      {
                                        DateConverter?.ISOToDisplayFormat(
                                          DateConverter?.convertToTimeZone(
                                            sale?.saledate,
                                            "Asia/Kolkata"
                                          )
                                        )?.date
                                      }
                                    </span>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {sale?.totalItems || 0} Item(s)
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    Number(sale?.grandtotal) || 0,
                                    "INR"
                                  )}
                                </td>
                                <td className="text-center">
                                  {sale?.status && (
                                    <span
                                      className={`badge rounded-pill ${getColor(
                                        sale?.status
                                      )}`}
                                    >
                                      {sale?.status.charAt(0).toUpperCase() +
                                        sale?.status.slice(1).toLowerCase()}
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <div className="order-actions opacity-0 opacity-md-100">
                                    <button
                                      type="button"
                                      className="btn-label-info shadow-none me-2"
                                      onClick={() => handleView(sale)}
                                      disabled={
                                        buttonLoading?.id === sale?._id &&
                                        buttonLoading?.type === "view"
                                      }
                                    >
                                      {buttonLoading?.id === sale?._id &&
                                      buttonLoading?.type === "view" ? (
                                        <CircularProgress
                                          size={20}
                                          className="text-primary"
                                        />
                                      ) : (
                                        <i className="bx bx-show"></i>
                                      )}
                                    </button>
                                    {sale?.status === "ACTIVE" && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn-label-primary shadow-none me-2"
                                          onClick={() => handleEdit(sale)}
                                          disabled={
                                            buttonLoading?.id === sale?._id &&
                                            buttonLoading?.type === "edit"
                                          }
                                        >
                                          {buttonLoading?.id === sale?._id &&
                                          buttonLoading?.type === "edit" ? (
                                            <CircularProgress
                                              size={20}
                                              className="text-primary"
                                            />
                                          ) : (
                                            <i className="ng ng-ng-edit-icon"></i>
                                          )}
                                        </button>
                                      </>
                                    )}
                                   
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div> */}
                        <Table
                          loading={isSalesLoading}
                          data={isSaleData}
                          onRowClick={(item) => handleView(item)}
                          columns={[
                            {
                              label: "S.No",
                              render: (_, index) => <>{index + 1} </>,
                            },
                            {
                              label: "Sale Mode",
                              render: (item) =>
                                item?.salemode && (
                                  <span
                                    className={`badge rounded-pill ${getBgColor(
                                      item?.salemode,
                                    )}`}
                                  >
                                    {formatTrackMode(item?.salemode)}
                                  </span>
                                ),
                            },
                            {
                              label: "Sale No",
                              render: (item) =>
                                item?.salemode && (
                                  <span
                                    className={`badge rounded-pill ${getBgTxtColor(
                                      item?.salemode,
                                    )}`}
                                  >
                                    {item?.saleno}
                                  </span>
                                ),
                            },
                            {
                              label: "Date",
                              render: (item) => (
                                <div className="d-flex flex-column">
                                  <span className="text-nowrap text-heading fw-medium">
                                    {
                                      DateConverter?.ISOToDisplayFormat(
                                        DateConverter?.convertToTimeZone(
                                          item?.saledate,
                                          "Asia/Kolkata",
                                        ),
                                      )?.date
                                    }
                                  </span>
                                </div>
                              ),
                            },
                            {
                              label: "Sale Items",
                              render: (item) => (
                                <> {item?.totalItems || 0} Item(s)</>
                              ),
                            },
                            {
                              label: "Grand Total",
                              render: (item) => (
                                <span className="text-right p-2">
                                  {formatCurrencyFun(item?.grandtotal)}
                                </span>
                              ),
                            },
                            {
                        label: "Status",
                        thClass:"w-12",
                        render: (item) => (
                          <div className="no-print position-relative">
                          <div className=" d-flex justify-content-center align-items-center">
                          <span
                            className={`stock-status-badge badge rounded-pill ${getColor(
                              item.saleTrack,
                              item.status,
                            )}`}
                          >
                            {getStatusLabel(item.saleTrack, item.status)}
                          </span>
                          <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                  <button
                                    type="button"
                                    className="btn-label-info shadow-none me-2"
                                    onClick={() => handleView(item)}
                                    disabled={
                                      buttonLoading?.id === item?._id &&
                                      buttonLoading?.type === "view"
                                    }
                                  >
                                    {buttonLoading?.id === item?._id &&
                                    buttonLoading?.type === "view" ? (
                                      <CircularProgress
                                        size={20}
                                        className="text-primary"
                                      />
                                    ) : (
                                      <ShowIcon/>
                                    )}
                                  </button>
                                </div>
                          </div>
                          </div>
                        ),
                      },
                            // {
                            //   label: "Status",
                            //   render: (item) =>
                            //     item?.status && (
                            //       <span
                            //         className={`badge rounded-pill ${getColor(
                            //           item?.status,
                            //         )}`}
                            //       >
                            //         {item?.status.charAt(0).toUpperCase() +
                            //           item?.status.slice(1).toLowerCase()}
                            //       </span>
                            //     ),
                            // },
                            // {
                            //   label: "Actions",
                            //   render: (item) => (
                            //     <div className="order-actions opacity-0 opacity-md-100">
                            //       <button
                            //         type="button"
                            //         className="btn-label-info shadow-none me-2"
                            //         onClick={() => handleView(item)}
                            //         disabled={
                            //           buttonLoading?.id === item?._id &&
                            //           buttonLoading?.type === "view"
                            //         }
                            //       >
                            //         {buttonLoading?.id === item?._id &&
                            //         buttonLoading?.type === "view" ? (
                            //           <CircularProgress
                            //             size={20}
                            //             className="text-primary"
                            //           />
                            //         ) : (
                            //           <i className="bx bx-show"></i>
                            //         )}
                            //       </button>
                            //       {/* {item?.status === "ACTIVE" && (
                            //         <>
                            //           <button
                            //             type="button"
                            //             className="btn-label-primary shadow-none me-2"
                            //             onClick={() => handleEdit(item)}
                            //             disabled={
                            //               buttonLoading?.id === item?._id &&
                            //               buttonLoading?.type === "edit"
                            //             }
                            //           >
                            //             {buttonLoading?.id === item?._id &&
                            //             buttonLoading?.type === "edit" ? (
                            //               <CircularProgress
                            //                 size={20}
                            //                 className="text-primary"
                            //               />
                            //             ) : (
                            //               <i className="ng ng-ng-edit-icon"></i>
                            //             )}
                            //           </button>
                            //         </>
                            //       )} */}
                            //     </div>
                            //   ),
                            // },
                          ].filter(Boolean)}
                        />
                      </>
                    ) : (
                      <p>No sales found.</p>
                    )}

                    {totalPages > 0 && (
                      <div className="d-flex justify-content-center mt-3">
                        <ReactPaginate
                          previousLabel={"← Previous"}
                          nextLabel={"Next →"}
                          breakLabel={"..."}
                          onPageChange={({ selected }) =>
                            setCurrentPage(selected)
                          }
                          pageRangeDisplayed={5}
                          pageCount={totalPages}
                          containerClassName="pagination"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      </div>
                    )}
                  </>
                )}

                {activeTab === "password" && (
                  <PasswordManager
                    customerId={customerData?.customerData?._id}
                  />
                )}
                {uRLs.ESTIMATE_MODULE === "true" &&
                  activeStoreModules("ESTIMATE") &&
                  (hasModulePermission("ESTIMATE") ||
                    permission === undefined) &&
                  blockedPermissions("ESTIMATE:list") &&
                  permission === undefined &&
                  activeTab === "estimate" && (
                    <EstimateList
                      customerId={customerData?.customerData?._id}
                    />
                  )}

                {uRLs.RETURN_SALE === "true" && activeTab === "returnsale" && (
                  <ReturnSaleList
                    customerId={customerData?.customerData?._id}
                    isActive={isActive}
                  />
                )}

                {activeTab === "jobCard" && (
                  <JobCardList customerId={customerData?.customerData?._id} />
                )}
                {/* {
                    activeTab === "editcustomer" && (
                    <div className="">
                      <button
                          type="button"
                          onClick={() => customerData?.customerData && openEditModal(customerData?.customerData)}
                          className="btn btn-primary mt-2 mt-lg-0"
                        >
                          <i className="ng ng-ng-edit-icon"></i> Edit Customer
                        </button>
                    </div>
                      )
                  } */}
                {/* {
                    activeTab === "deletecustomer" && (
                      <>
                      <div>
                      <button
                    type="button"
                    onClick={() => customerData?.customerData && openDeleteModal(customerData?.customerData)}
                    className="btn btn-danger mt-2 mt-lg-0"
                  >
                    <i className="bx bx-trash"></i> Delete Customer
                  </button></div>
                  </>
                      )
                  } */}
              </div>
            </div>

            {/* {isDeleteModalOpen && (
              <DeleteModal
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                isLable={" Sale " + isDeleteData?.saleno}
                isBtnLoading={isBtnLoading}
              />
            )} */}

            {isSelectedPlater && (
              <ViewPaylater
                isData={isSelectedPlater}
                onClose={handleClosePaylater}
                isBtnLoading={isBtnLoading}
                onDataUpdate={handleDataUpdate}
              />
            )}

            {isDeleteModalOpen && (
              <DeleteModal
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                isLable={" Customer " + isDeleteData?.name}
                isBtnLoading={isBtnLoading}
              />
            )}

            {isEditModalOpen && (
              <EditCutomer
                editData={isEditData}
                onClose={closeEditModal}
                onEdit={handleUpdte}
                isBtnLoading={isBtnLoading}
                groupId={groupId}
                selectedGroupDetails={selectedGroupDetails}
                onEditGroupData={onEditGroupData}
                groupName={groupName}
                onChangeGroup={onChangeGroup}
                onNewGroupsIn={handleCustomerGroupAdd}
                // resetAll={true}
                newGroup={newGroupName}
                error={error}
                setErrors={setErrors}
              />
            )}
            <div className="modal-footer  d-flex justify-content-between align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>
              {totalCustomer > 1 && (
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary me-2"
                  onClick={handlePrevCustomer}
                >
                  <LeftArrowAltIcon/> Prev Customer      
                </button>
                <button
                  type="button"
                   style={{
                    background: "#FFF4E5",
                    color: "#D97706",
                    border: "1px solid #FCD34D",
                  }}
                  className="btn btn btn-primary "
                  onClick={handleNextCustomer}
                >
                  Next Customer       <RightArrowAltIcon/>
                </button>
              </div>
              )}
            </div>
            {addNewGroupOpen && (
              <AddGroup
                onClose={handleNewGroupClose}
                onNewGroupIn={handleGrouAdd}
                // isBtnLoading={addGroupload}
              />
            )}
          </div>
        </div>
      </div>
      {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={isViewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}
      {templateId && isViewModalOpen && (
      <TemplateModalLayout
                isOpen={isViewModalOpen}
                isData={isViewData}
                onClose={handleClose}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                setSaleData={setViewData}
                isActive={isActive}
              />  
      )}    
    </div>
  );
};

export default CustomerView;
